import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/thum_img/kp708b/sub4_1/adf6257b1cbed48063e7e24a90e9e467_water__c1_w280_h397.jpg'


const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content" }
const _hoisted_4 = { class: "menu-A-read-wrap" }
const _hoisted_5 = { class: "btn" }

import BoardNavbar from "@/views/product/activity/Navbar.vue";
import Banner from "@/components/Banner.vue";

import { watch } from "vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRouter } from "vue-router";
import { useAuth } from "@/composables/useAuth";
import { useAlertDialog } from "@/composables/useAlert";

export default /*@__PURE__*/_defineComponent({
  __name: 'University',
  setup(__props) {

const useAlert = useAlertDialog();
const { isLoggedIn } = useAuth();
const router = useRouter();
watch(
  isLoggedIn,
  async (newValue) => {
    if (newValue === false) {
      await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
      // TODO : 단순히 뒤로 갈지 향후 확인 후 변경 가능.
      // router.back();
      router.push({ name: USER_ROUTES.Home.Name });
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_n_space = _resolveComponent("n-space")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(isLoggedIn))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(Banner, {
          title: "Activity",
          subtitle: "Activity",
          description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
        }),
        _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"sub_scroll_wrap\" data-v-45d00da6><div class=\"width_wrap\" data-v-45d00da6><div data-v-45d00da6><ul class=\"scroll_nav\" data-v-45d00da6><li class=\"on\" data-v-45d00da6><a href=\"/myboard/sub4_1\" alt=\"재능진로전공직업 탐색 프로젝트\" data-v-45d00da6>재능진로전공직업 탐색 프로젝트</a></li><li data-v-45d00da6><a href=\"/myboard/sub4_2\" alt=\"꿈 창업 프로젝트\" data-v-45d00da6>꿈 창업 프로젝트</a></li><li data-v-45d00da6><a href=\"/myboard/sub4_3\" alt=\"데이터 사이언스 체험 활동\" data-v-45d00da6>데이터 사이언스 체험 활동</a></li><li data-v-45d00da6><a href=\"/myboard/sub5_2\" alt=\"성장–폴리오 과정\" data-v-45d00da6>성장–폴리오 과정</a></li></ul></div><i class=\"prev\" data-v-45d00da6></i><i class=\"next\" data-v-45d00da6></i></div></div>", 1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "sub_subject" }, "재능진로전공직업 탐색 프로젝트", -1)),
            _createElementVNode("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("div", null, [
                _createElementVNode("ul", { class: "line line4" }, [
                  _createElementVNode("li", null, "PUTT2.0기반 직업탐색 프로젝트"),
                  _createElementVNode("li", null, [
                    _createElementVNode("dl", { class: "line2" }, [
                      _createElementVNode("dt", null, "제목"),
                      _createElementVNode("dd", null, "“미래 작업공간을 건립하다!”")
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", null, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("figure", null, [
                      _createVNode(_component_n_space, { justify: "center" }, {
                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: ""
                          }, null, -1)
                        ])),
                        _: 1
                      })
                    ])
                  ]),
                  _cache[1] || (_cache[1] = _createStaticVNode("<li data-v-45d00da6><dl data-v-45d00da6><dt data-v-45d00da6>목적</dt><dd data-v-45d00da6> 본 활동은 학생의 경험을 바탕으로, 미래 최적의 재능을 발휘할 전공 탐색을 목적으로 한다 </dd></dl><dl data-v-45d00da6><dt data-v-45d00da6>목표</dt><dd data-v-45d00da6> 목표 1. (강의를 들으면서) 세상 이해 및 자기 이해를 통해 자기개념을 정립한다.<br data-v-45d00da6> 목표 2. 팀 구성원 간 재능 및 관심을 소개, 공유, 논의 과정을 통해 전공 분야에 관한 인식을 다각적으로 탐색, 심화한다.<br data-v-45d00da6> 목표 3. ‘미래 실험공간 건립 프로젝트’ 참여를 위한 가상의 과제 제안서 작성을 통해 관심 전공을 면밀하게 탐색한다. <br data-v-45d00da6> 목표 4. ‘목표 3’을 통해 팀 과업 과정에서 만나게 된 경험을 팀별로 발표하고, 자기소개용 에세이를 작성, 제출한다. </dd></dl><dl data-v-45d00da6><dt data-v-45d00da6>대상</dt><dd data-v-45d00da6>대학1 – 대학4</dd></dl><dl class=\"line2\" data-v-45d00da6><dt data-v-45d00da6>시간</dt><dd data-v-45d00da6>6시간 (사전 1시간ㅣ집합 5시간)</dd></dl></li>", 1))
                ])
              ]),
              _cache[4] || (_cache[4] = _createStaticVNode("<div data-v-45d00da6><ul class=\"line line4\" data-v-45d00da6><li data-v-45d00da6>JIGSAW 수업</li><li data-v-45d00da6><dl class=\"line2\" data-v-45d00da6><dt data-v-45d00da6>재료</dt><dd data-v-45d00da6> •자료 1. 팀별 명단: PUTT2.0 결과를 기반으로, 팀(2인1팀)을 구성(팀 내, 유사한 재능 유형으로), 명단을 조직<br data-v-45d00da6> •자료 2. 활동지: ‘미래 실험공간 건립’ 프로젝트 수행을 위한 (가상)과업 제안서 (Worksheet 1 – 4) <br data-v-45d00da6> •자료 3. 또래평가지: 다른 팀의 ‘과업제안서’ 평가에 사용할 ‘과업제안서 평가지’ (Worksheet 5)<br data-v-45d00da6> •자료 4. 에세이 양식: “미래 글로벌 리더의 창조적 경험” 작성 (Worksheet. 6) </dd></dl></li></ul></div><div data-v-45d00da6><ul class=\"line\" data-v-45d00da6><li data-v-45d00da6> 결과물<br data-v-45d00da6> + PUTT2.0 결과리포트<br data-v-45d00da6> + 팀 과업 제안서<br data-v-45d00da6> + 발표 자료 </li><li data-v-45d00da6><dl class=\"line2\" data-v-45d00da6><dt data-v-45d00da6>구성</dt><dd data-v-45d00da6> • 모듈 1. [사전 진단] PUTT2.0 - 1주일 전 - On-Line 실시 – 팀 배치<br data-v-45d00da6> • 모듈 2. [강의] (1) PUTT2.0 결과 – 전공별 사례 소개, (2) 과제 소개 및 안전교육<br data-v-45d00da6> • 모듈 3. [과제 수행] (1) 팀 구성원 소개, (2) 직업 논의 (학과명/ 분야명/ 전문성 및 역량/ 종목 등) <br data-v-45d00da6> (3) 아이템 논의 및 결정, (4) 개별 직무 및 조직 구성, 세부 내용 구성<br data-v-45d00da6> • 모듈 4. [제안서 및 에세이 작성] (1) 사업 논의 및 제안서 작성, 발표 (2) 자기소개를 위한 에세이 작성 </dd></dl></li></ul></div><div data-v-45d00da6><ul class=\"line\" data-v-45d00da6><li data-v-45d00da6>진행: 관리자</li><li data-v-45d00da6><dl class=\"line2\" data-v-45d00da6><dt data-v-45d00da6>활용</dt><dd data-v-45d00da6> •전공 탐색을 통해 개인의 재능을 재구조화 하여 관심 분야에서의 경쟁력을 높임 </dd></dl></li></ul></div>", 3)),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: `${_unref(USER_ROUTES).Product.Activity.Talent.Path}`
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("목록")
                  ])),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})